/**
 * Continue shopping: return to the last non-cart storefront URL.
 * Shopify has no built-in cart return_to param; history.back() is unreliable
 * (theme editor, drawer pushState, redirects).
 */
(() => {
  const STORAGE_KEY = 'continueShoppingUrl';

  const getCartPath = () => {
    try {
      return new URL(Theme?.routes?.cart_url || '/cart', window.location.origin).pathname.replace(/\/$/, '') || '/cart';
    } catch {
      return '/cart';
    }
  };

  const normalizePath = (pathname) => {
    const path = pathname.replace(/\/$/, '');
    return path === '' ? '/' : path;
  };

  const isCartPath = (pathname) => normalizePath(pathname) === getCartPath();

  const isSameOrigin = (url) => {
    try {
      return new URL(url, window.location.origin).origin === window.location.origin;
    } catch {
      return false;
    }
  };

  const rememberCurrentPage = () => {
    if (isCartPath(window.location.pathname)) return;
    sessionStorage.setItem(STORAGE_KEY, window.location.href);
  };

  const resolveContinueUrl = () => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && isSameOrigin(stored)) {
      try {
        if (!isCartPath(new URL(stored).pathname)) return stored;
      } catch {
        // ignore invalid stored URL
      }
    }

    if (document.referrer && isSameOrigin(document.referrer)) {
      try {
        if (!isCartPath(new URL(document.referrer).pathname)) return document.referrer;
      } catch {
        // ignore invalid referrer
      }
    }

    return Theme?.routes?.root_url || '/';
  };

  rememberCurrentPage();
  window.addEventListener('pageshow', rememberCurrentPage);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-continue-shopping]');
    if (!trigger) return;

    event.preventDefault();
    window.location.assign(resolveContinueUrl());
  });
})();
